import React, { useEffect } from 'react';
import { CheckboxesField, TextField } from '../../01_atoms/FormElements';
import { useFormState } from 'react-final-form';
import { connect } from 'react-redux';
import { required } from '../../../utils/formFieldValidators';
import CompanyIcon from '../../../public/static/icons/company.svg';

import styles from './index.module.scss';

type Props = {
  globalSettings: {
    generalSettings: {
      donateAsCompanyLabel: string;
      donateAsCompanyDescription: string;
    };
  };
};

const Company = ({ globalSettings: { generalSettings } }: Props) => {
  const formState = useFormState();

  const isCompanyDonation =
    formState.values.company_donation &&
    formState.values.company_donation[0] === 'company_donation';

  useEffect(() => {
    // Unfortunately useRef doesn't work in this case since element is hidden by default.
    const companyNameField = document ? document.getElementById('company_name') : null;
    if (isCompanyDonation && companyNameField) {
      companyNameField.focus();
    }
  }, [isCompanyDonation]);

  return (
    <div className={styles['company-donation']}>
      <CheckboxesField
        name="company_donation"
        options={[
          {
            value: 'company_donation',
            label: generalSettings.donateAsCompanyLabel,
          },
        ]}
        label=""
      />
      {isCompanyDonation && (
        <div className={styles['company-donation__highlighted-field']}>
          <TextField
            name="company_name"
            label="Company name"
            validate={required('Please enter your company name')}
            isRequired={isCompanyDonation}
            placeholder="Your company"
            info={generalSettings.donateAsCompanyDescription}
            icon={<CompanyIcon />}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ globalSettings }: Props) => ({
  globalSettings,
});

export default connect(mapStateToProps)(Company);
